import {Fab} from "@mui/material";
import {ArrowForward} from "@mui/icons-material";
import {useNavigate} from "react-router-dom";
import './BackComponent.scss'


export default function BackComponent() {
    const nav = useNavigate();

    return <div className='floatBTNBack'>
        <Fab variant="circular" size={"small"} onClick={() => nav(-1)}>
            <ArrowForward></ArrowForward>
        </Fab>
    </div>
}